import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'brn-form-input-editor',
  templateUrl: './form-input-editor.component.html',
  styleUrls: ['./form-input-editor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormInputEditorComponent),
      multi: true,
    },
  ],
})
export class FormInputEditorComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  @Input()
  label!: string;

  @Input()
  value!: string;

  @Input()
  placeholder!: string;

  @Output() valueChange = new EventEmitter<string>();

  currentValue: string = '';

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    width: 'auto',
    translate: 'no',
    enableToolbar: true,
    showToolbar: true,
    defaultParagraphSeparator: 'p',
    toolbarHiddenButtons: [
      [
        'fontSize',
        'textColor',
        'backgroundColor',
        'insertVideo',
        'insertImage',
        'unlink',
        'removeFormat',
        'undo',
        'redo',
        'subscript',
        'superscript',
        'indent',
        'outdent',
      ],
      [
        'fontName',
        'fontSize',
        'textColor',
        'backgroundColor',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode',
      ],
    ],
  };

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  constructor() {}

  ngOnInit(): void {
    this.setEditorWidth();
    window.addEventListener('resize', this.setEditorWidth.bind(this));
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.setEditorWidth.bind(this));
  }

  writeValue(value: string): void {
    this.currentValue = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onValueChange(val: string): void {
    this.currentValue = val;
    this.valueChange.emit(this.currentValue);
  }

  setEditorWidth(): void {
    const screenWidth = window.innerWidth;

    if (screenWidth <= 768) {
      this.editorConfig.width = 'auto';
    } else {
      this.editorConfig.width = '420px';
    }
  }
}
